<template>
  <div>
    <b-modal
        v-model="showModalInternal"
        id="drugstore-group-members-modal"
        :title="modalTitle"
        title-class="font-18"
        hide-footer
        size="xl"
        @hidden="onModalHidden"
    >
      <div class="p-3">
        <div class="d-flex justify-content-between align-items-center mb-3">
          <h6 class="mb-0">Lista aptek w grupie</h6>
          <div class="d-flex gap-2">
            <button class="btn btn-sm btn-success" @click="openDrugstoreSelector">
              <i class="fas fa-plus-circle me-1"></i> Dodaj apteki
            </button>
            <button class="btn btn-sm btn-primary" @click="openDrugstoreSelectorReplace">
              <i class="fas fa-sync-alt me-1"></i> Zastąp listę
            </button>
          </div>
        </div>

        <CommonTable2
            :table="tableData"
            :key="tableData.data"
            rowIdentifier="drugstoreClientId"
            @onItemAction="handleItemAction($event)"
            @onMassAction="handleMassAction($event)"
            :showPaginationTop="false"
            :showPaginationBottom="false"
            :showMassActions="true"
            :showRowActions="true"
            :multiselect="true"
            :enableRowSelection="false"

        />

        <div class="d-flex justify-content-end mt-4 pt-3 border-top">
          <button class="btn btn-outline-secondary px-4" @click="closeModal">
            Zamknij
          </button>
        </div>
      </div>
    </b-modal>

    <!-- External selector modal -->
    <DrugstoreListModal
        v-if="showSelector"
        :showModal="showSelector"
        @update:showModal="showSelector = $event"
        @onApply="onDrugstoresSelected"
        :showMassActions="false"
        :showRowActions="false"
        :showAddButton="false"
        :multiselect="true"
        title="Wybierz apteki do dodania"
    />
  </div>
</template>

<script>
import {BModal} from "bootstrap-vue-next";
import {useCommonAppModule} from "@/state/pinia/commonAppModule";
import CommonTable2 from "@/components/widgets/CommonTable2.vue";
import DrugstoreListModal from "./DrugstoreListModal.vue";
import Swal from "sweetalert2";
import {log} from "@/state/pinia/log";
import {apiRequestsHelper} from "@/state/pinia/apiRequestHelper";

export default {
  name: "DrugstoreGroupMembersModal",
  components: {BModal, CommonTable2, DrugstoreListModal},
  props: {
    showModal: {
      type: Boolean,
      required: true
    },
    groupId: {
      type: Number,
      required: true
    },
    groupName: {
      type: String,
      default: ""
    }
  },
  emits: ["update:showModal"],
  data() {
    return {
      showModalInternal: false,
      showSelector: false,
      selectorMode: 'ADD', // 'ADD' or 'REPLACE'
      refreshTable: true,
      tableData: {
        headers: [
          {key: "drugstoreClientId", text: "Numer", type: "text", sortable: false},
          {key: "name", text: "Nazwa", type: "text", sortable: false},
          {key: "nip", text: "NIP", type: "text", sortable: false},
          {key: "actions", text: "Akcje", type: "actions", sortable: false}
        ],
        massActions: [{
          action: "mass-remove-member",
          text: "Usuń apteki",
          icon: "fas fa-trash-alt",
          class: "btn btn-danger mass-operations-btn",
          enabled: true,
        }],
        data: []
      }
    };
  },
  computed: {
    commonModule() {
      return useCommonAppModule();
    },
    modalTitle() {
      return `Zarządzanie aptekami w grupie: ${this.groupName}`;
    }
  },
  methods: {
    closeModal() {
      this.showModalInternal = false;
    },
    onModalHidden() {
      this.$emit("update:showModal", false);
    },
    fetchMembers() {
      this.refreshTable = false;
      this.commonModule.httpGetDrugstoreGroupById({groupId: this.groupId}).then((response) => {
        const group = response.data.payload;
        let members = [];
        console.log("Fetching drugstore details for group members:", group.drugstoresClientIds);
        if (group.drugstoresClientIds && Array.isArray(group.drugstoresClientIds)) {

          this.commonModule.httpGetDrugstoresForClientIds({drugstoresClientIds: group.drugstoresClientIds}).then((response) => {
            console.log("Fetched drugstore details for group members:", response.data.payload);
            if (response.status === 200) {

              members = response.data.payload;
            } else {
              return apiRequestsHelper.handleResponseWithDialogs(response, false);
            }
          })
              .catch((error) => {
                return apiRequestsHelper.catchResponseError(error, "httpGetDrugstoresForClientIds");
              }).then(() => {
                    this.tableData.data = members.map(m => ({
                      ...m,
                      actions: [
                        {
                          icon: "fas fa-trash-alt",
                          class: "btn btn-danger btn-sm",
                          text: "",
                          action: "remove-member",
                          enabled: true
                        }
                      ]
                    }));
                    this.refreshTable = true;
          })


        }


      });
    },
    handleItemAction(event) {
      if (event.action.action === "remove-member") {
        this.removeMember([event.itemData["drugstoreClientId"]]);
      }
    },
    handleMassAction(event) {
      if (event.action.action === "mass-remove-member") {
        this.removeMember(event.items);
      }
    },
    removeMember(drugstoreClientsIds) {
      Swal.fire({
        title: "Czy na pewno chcesz usunąć aptekę z grupy?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonText: "Tak",
        cancelButtonText: "Nie"
      }).then((result) => {
        if (result.isConfirmed) {
          this.commonModule.httpRemoveDrugstoresFromGroup({
            groupId: this.groupId,
            drugstoreIds: drugstoreClientsIds
          }).then((res) => {
            this.fetchMembers();
          });
        }
      });
    },
    openDrugstoreSelector() {
      this.selectorMode = 'ADD';
      this.showSelector = true;
    },
    openDrugstoreSelectorReplace() {
      this.selectorMode = 'REPLACE';
      this.showSelector = true;
    },
    onDrugstoresSelected(selectedObjects) {
      this.showSelector = false;
      if (!selectedObjects || selectedObjects.length === 0) return;

      const ids = selectedObjects.map(obj => {
        if (obj.drugstoreClientId) return obj.drugstoreClientId;
        return null;
      }).filter(id => id !== null);

      if (ids.length === 0) {
        Swal.fire("Błąd", "Wybrane apteki nie posiadają poprawnego identyfikatora.", "error");
        return;
      }

      let action;
      if (this.selectorMode === 'REPLACE') {
        action = this.commonModule.httpSetGroupDrugstores({groupId: this.groupId, drugstoreIds: ids}).then(()=>{
          this.fetchMembers()
        });
      } else {
        action = this.commonModule.httpAddDrugstoresToGroup({groupId: this.groupId, drugstoreIds: ids}).then(()=>{
          this.fetchMembers()
        });
      }

      action.then((res) => {
        if (res && res.success) {
          this.fetchMembers();
        }
      });
    }
  },
  watch: {
    showModal(newVal) {
      this.showModalInternal = newVal;
      if (newVal) {
        this.fetchMembers();
      }
    }
  }
};
</script>

<style scoped>
</style>
